import {
  Copy,
  Flex,
  Stack,
  SvgArrowDown,
  SvgCaretPair,
} from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { CertificateAttribute } from 'src/types/TaxExemptionCertificate';

type AcceptedSortFields = SortFields | CertificateAttribute;

export interface ISortableColumnProps {
  label: string;
  previousSortOrder: SortOrder;
  sortField: AcceptedSortFields;
  previousSortField: AcceptedSortFields;
  onSortColumnClick: (field: string, order: string) => void;
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortFields {
  WHEN_FOR = 'WHEN_FOR',
  DINER_NAME = 'DINER_NAME',
  RESTAURANT = 'RESTAURANT',
  LAST_NAME = 'LAST_NAME',
  EMAIL = 'EMAIL',
  NAME = 'NAME',
  EXPENSE_CODE = 'EXPENSE_CODE',
}

export function SortableColumn({
  label,
  previousSortOrder,
  sortField,
  previousSortField,
  onSortColumnClick,
}: ISortableColumnProps): JSX.Element {
  function onSort(
    sortField: AcceptedSortFields,
    previousSortDirection: SortOrder
  ) {
    let sortDirection: SortOrder;
    if (sortField === previousSortField) {
      sortDirection =
        previousSortDirection === SortOrder.ASC
          ? SortOrder.DESC
          : SortOrder.ASC;
    } else {
      sortDirection = SortOrder.DESC;
    }

    onSortColumnClick(sortField, sortDirection);
  }

  return (
    <>
      <Flex alignItems="center">
        <Stack x="x-sm">
          <Copy variant="body" color="secondaryText">
            {label}
          </Copy>
        </Stack>

        {/* TODO: this should be a button to be more accessible */}
        <Flex
          data-testid={`sort-by-${sortField}`}
          alignItems="center"
          onClick={() => onSort(sortField, previousSortOrder)}
        >
          <Copy variant="body" color="secondaryText">
            {previousSortField === sortField ? (
              <>
                {previousSortOrder === SortOrder.ASC ? (
                  // there is no SvgArrowUp so we are using the rotate 180 degrees down arrow
                  <SvgArrowDown
                    size="16px"
                    className="iconArrowUp"
                    data-testid="icon-arrow-up"
                  />
                ) : (
                  <SvgArrowDown size="16px" data-testid="icon-arrow-down" />
                )}
              </>
            ) : (
              <SvgCaretPair size="16px" data-testid="icon-arrow-caret-pair" />
            )}
          </Copy>
        </Flex>
      </Flex>
    </>
  );
}
